module.exports = __webpack_public_path__ + "images/liinilaevad/android-icon-192x192.png";